import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { HiPhone, HiMail } from 'react-icons/hi'
import SEO from '../../components/SEO/SEO'
import { seoBreadcrumbPair } from '../../utils/seoUtils'
import './Contact.css'

function Contact() {
  const { t } = useTranslation()

  const breadcrumbItems = useMemo(
    () => seoBreadcrumbPair(t('common.home'), t('common.contact'), 'contact'),
    [t]
  )

  return (
    <div className="contact-page">
      <SEO 
        title={t('common.contact')}
        description={t('contact.description', 'Contact SUMA International - International School Union of Martial Arts')}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="container">
        <div className="contact-hero">
          <h1>{t('common.contact')}</h1>
          <p className="contact-intro">
            {t('contact.intro', 'Get in touch with SUMA International. We are here to answer your questions, provide information about membership, certifications, events, and more.')}
          </p>
          <p className="contact-note">
            {t('contact.contactNote', 'Please use the phone number or email below — this is the fastest way to reach us.')}
          </p>
        </div>
        <div className="contact-content contact-content--single">
          <div className="contact-info">
            <h2>{t('contact.info', 'Contact Information')}</h2>
            <p className="contact-info-text">
              {t('contact.infoText', 'You can reach us through the following channels:')}
            </p>
            <div className="contact-details">
              <div className="contact-card">
                <div className="contact-card-icon">
                  <HiPhone />
                </div>
                <div className="contact-card-content">
                  <h3 className="contact-card-title">{t('footer.phone')}</h3>
                  <a href="tel:+73432269909" className="contact-card-value">+7 (343) 226-99-09</a>
                </div>
              </div>
              <div className="contact-card">
                <div className="contact-card-icon">
                  <HiMail />
                </div>
                <div className="contact-card-content">
                  <h3 className="contact-card-title">{t('footer.email')}</h3>
                  <a href="mailto:sumaunion@yandex.ru" className="contact-card-value">sumaunion@yandex.ru</a>
                </div>
              </div>
            </div>
            <div className="contact-hours">
              <h3>{t('contact.hours', 'Office Hours')}</h3>
              <p>{t('contact.hoursText', 'Monday - Friday: 9:00 - 18:00 (Moscow Time)')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact
